import React from 'react'
import Home from './pages/home/Home'

export default function Tours() {
  return (
    <div><Home/></div>
  )
}
